import type { ScreenerFilterData } from "epsm-api-types/models";
import { HttpClient, type IHttpClient } from "@/services/HttpClient";

export class ScreenerFilterDataService {
	private constructor(private httpClient: IHttpClient) {}

	private static instance: ScreenerFilterDataService;

	static create() {
		if (!ScreenerFilterDataService.instance) {
			ScreenerFilterDataService.instance = new ScreenerFilterDataService(
				HttpClient.create(),
			);
		}
		return ScreenerFilterDataService.instance;
	}

	async getData(name: string, subField?: string): Promise<ScreenerFilterData> {
		const getUrl = () => {
			return subField
				? `/screener/filters-list/${name}.${subField}`
				: `/screener/filters-list/${name}`;
		};

		const { data } = await this.httpClient.get<
			Record<string, ScreenerFilterData>
		>(getUrl());

		return data.data;
	}
}
